var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14465_12683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14465_12683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 14.325L10.85 13.45L9 15.75V12.9L6.2 12L9 11.1V8.25L10.85 10.575L13.7 9.7L11.925 12L13.7 14.325ZM23 18H15.275C14.575 18.6333 13.775 19.125 12.875 19.475C11.975 19.825 11.0167 20 10 20C7.76667 20 5.875 19.225 4.325 17.675C2.775 16.125 2 14.2333 2 12C2 9.76667 2.775 7.875 4.325 6.325C5.875 4.775 7.76667 4 10 4C11.0167 4 11.975 4.175 12.875 4.525C13.775 4.875 14.575 5.36667 15.275 6L23 6L21 12L23 18ZM16 12C16 10.3333 15.4167 8.91667 14.25 7.75C13.0833 6.58333 11.6667 6 10 6C8.33333 6 6.91667 6.58333 5.75 7.75C4.58333 8.91667 4 10.3333 4 12C4 13.6667 4.58333 15.0833 5.75 16.25C6.91667 17.4167 8.33333 18 10 18C11.6667 18 13.0833 17.4167 14.25 16.25C15.4167 15.0833 16 13.6667 16 12ZM20.025 16L19 12L20.025 8H16.925C17.2583 8.58333 17.5208 9.2125 17.7125 9.8875C17.9042 10.5625 18 11.2667 18 12C18 12.7333 17.9042 13.4375 17.7125 14.1125C17.5208 14.7875 17.2583 15.4167 16.925 16H20.025Z",
    fill: "#00A3E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBlue);
export default __webpack_public_path__ + "static/media/badge-blue.5ad67647.svg";
export { ForwardRef as ReactComponent };